import iconPin from "../../../../assets/icon_as_pin.svg";
const LabelInfo = () => {
  return (
    <div className="fixed left-0 w-full px-4 bottom-3">
      <p className="flex items-center gap-4 px-5 py-3.5 bg-slate-50 rounded-[20px] border border-violet-50 text-stone-700 font-medium text-sm break-keep">
        <img src={iconPin} alt="" />
        제품의 제조사는 상품에 부착된 라벨에서 확인 가능합니다.
      </p>
    </div>
  );
};

export default LabelInfo;
